var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from "prop-types";

import { Widget, WidgetHeader, WidgetTab, WidgetBody, WidgetFooter, WidgetLoading } from "../";
import { getGaDataByMetrics } from "../../resources/functions/";
import { FormatMetric } from "../";
import { Chart } from "../";

import "./AnalyticsReportMetrics.scss";

var AnalyticsReportMetrics = (_temp2 = _class = function (_Component) {
    _inherits(AnalyticsReportMetrics, _Component);

    function AnalyticsReportMetrics() {
        var _temp, _this, _ret;

        _classCallCheck(this, AnalyticsReportMetrics);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            tabIndex: 0,
            tabs: undefined,
            loading: true,
            values: {}
        }, _this.componentDidUpdate = function (prevProps, prevState) {
            if (prevProps.report !== _this.props.report) {
                _this.getReport();
            }
        }, _this.getCompareHeader = function (col) {
            var data = col.data;
            var _data$ = data[0],
                metric = _data$.metric,
                xFormat = _data$.xFormat,
                yFormat = _data$.yFormat;


            var s1 = data[0];
            var s2 = data[1];

            var value = React.createElement(FormatMetric, { type: "INTEGER", value: s1.total }); // formatNumber(s1.total);

            var change = void 0,
                trending = void 0;

            if (s1.total > s2.total) {
                change = (s1.total - s2.total) / s1.total * 100;
                trending = "up";
            } else if (s2.total > s1.total) {
                change = (s2.total - s1.total) / s2.total * 100;
                trending = "down";
            } else {
                change = 0;
                trending = "flat";
            }

            change = React.createElement(FormatMetric, { type: "PERCENT", value: change }); // formatPercent(change)

            if (yFormat === "PERCENT") {
                value = React.createElement(FormatMetric, { type: "PERCENT", value: s1.average }); // formatPercent(s1.average)
            }

            if (yFormat === "TIME") {
                value = React.createElement(FormatMetric, { type: "DURATION", value: s1.average }); // formatDuration(s1.average)
            }

            return {
                id: metric,
                label: metric,
                value: value,
                change: change,
                trending: trending
            };
        }, _this.getHeader = function (col) {
            var metric = col.metric,
                xFormat = col.xFormat,
                yFormat = col.yFormat,
                data = col.data,
                total = col.total,
                average = col.average;


            if (!data.length) {
                return false;
            }

            var compare = _this.props.compare;


            if (compare && data[0] && data[1]) {
                return _this.getCompareHeader(col);
            }

            var value = React.createElement(FormatMetric, { type: "INTEGER", value: total }); // formatNumber(total);

            if (yFormat === "PERCENT") {
                value = React.createElement(FormatMetric, { type: "PERCENT", value: average }); // formatPercent(average)
            }

            if (yFormat === "TIME") {
                value = React.createElement(FormatMetric, { type: "DURATION", value: average }); // formatDuration(average)
            }

            return {
                id: metric,
                label: metric,
                value: value
            };
        }, _this.onSelectTab = function (index) {
            _this.setState({
                tabIndex: index
            });
        }, _this.renderChart = function (metric, index) {
            var _this$props = _this.props,
                theme = _this$props.theme,
                colors = _this$props.colors,
                type = _this$props.type,
                compare = _this$props.compare,
                stacked = _this$props.stacked;


            var yScaleMax = "auto";

            var maximum = metric.maximum,
                minimum = metric.minimum,
                yFormat = metric.yFormat,
                data = metric.data,
                startDate = metric.startDate,
                endDate = metric.endDate,
                days = metric.days;


            if (yFormat === "PERCENT") {
                yScaleMax = Math.ceil((maximum + 1) / 10) * 10;
                console.log("MAX", yScaleMax);
            }

            if (index === _this.state.tabIndex) {

                return React.createElement(Chart, _extends({}, metric, { type: type, compare: compare, stacked: stacked, yScaleMax: yScaleMax, outerMargin: { top: 20, right: 20, bottom: 20, left: 20 }, theme: theme, colors: colors, key: index }));
            }

            return false;
        }, _this.renderTab = function (tab, index) {
            var theme = _this.props.theme;

            var _this$getHeader = _this.getHeader(tab),
                id = _this$getHeader.id,
                label = _this$getHeader.label,
                value = _this$getHeader.value,
                change = _this$getHeader.change,
                trending = _this$getHeader.trending;

            var selected = _this.state.tabIndex === index;

            if (change && trending) {

                return React.createElement(
                    WidgetTab,
                    { theme: theme, selected: selected, onClick: function onClick() {
                            return _this.onSelectTab(index);
                        }, key: index },
                    React.createElement(
                        "h2",
                        { className: "admin-metric__label" },
                        React.createElement(FormatMetric, { name: id })
                    ),
                    React.createElement(
                        "h3",
                        { className: "admin-metric__value" },
                        value
                    ),
                    React.createElement(
                        "p",
                        { className: "admin-metric__change", "data-trending": trending },
                        change
                    )
                );
            }

            return React.createElement(
                WidgetTab,
                { theme: theme, selected: selected, onClick: function onClick() {
                        return _this.onSelectTab(index);
                    }, key: index },
                React.createElement(
                    "h2",
                    { className: "admin-metric__label" },
                    label
                ),
                React.createElement(
                    "h3",
                    { className: "admin-metric__value" },
                    value
                )
            );
        }, _this.getReport = function () {
            var _this$props2 = _this.props,
                report = _this$props2.report,
                metrics = _this$props2.metrics,
                dimension = _this$props2.dimension;


            _this.setState({
                tabs: undefined,
                loading: true
            });

            if (!report) {
                return false;
            }

            var data = getGaDataByMetrics(report, metrics, dimension);
            var tabs = Object.values(data);

            _this.setState({
                tabs: tabs,
                loading: false
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AnalyticsReportMetrics.prototype.componentDidMount = function componentDidMount() {
        this.getReport();
    };

    AnalyticsReportMetrics.prototype.render = function render() {
        var _props = this.props,
            theme = _props.theme,
            widgetType = _props.widgetType,
            widgetSize = _props.widgetSize,
            debug = _props.debug,
            reportType = _props.reportType,
            scope = _props.scope,
            loadingTitle = _props.loadingTitle,
            loadingDescription = _props.loadingDescription;
        var _state = this.state,
            tabs = _state.tabs,
            values = _state.values;


        var loading = this.state.loading || this.props.loading;

        if (loading) {
            return React.createElement(
                Widget,
                this.props,
                React.createElement(WidgetLoading, { theme: theme, title: loadingTitle, description: loadingDescription })
            );
        }

        return React.createElement(
            Widget,
            this.props,
            React.createElement(
                WidgetHeader,
                null,
                tabs.map(this.renderTab)
            ),
            React.createElement(
                WidgetBody,
                null,
                tabs.map(this.renderChart)
            )
        );
    };

    return AnalyticsReportMetrics;
}(Component), _class.defaultProps = {
    loadingTitle: "Loading metrics report",
    reportType: "metrics",
    scope: undefined,
    widgetType: "analytics-report-metrics",
    widgetSize: "2:6",
    theme: {},
    report: undefined,
    metrics: [],
    dimension: undefined,
    type: "line",
    compare: true,
    stacked: false,
    debug: false
}, _temp2);
AnalyticsReportMetrics.propTypes = process.env.NODE_ENV !== "production" ? {
    loadingTitle: PropTypes.string,
    loadingDescription: PropTypes.string,
    scope: PropTypes.string
} : {};


export default AnalyticsReportMetrics;